import React from "react";
import { useDispatch, /* useSelector */ } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import './ValidationForms.css';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Input,
  Row
} from "reactstrap";
import history from '../../../services/history';

import { signInRequest } from '../../../store/modules/auth/actions';

import LogoHeader from "../../../assets/img/brand/logo-novida-header.svg";
import "../../../scss/login.scss";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const validationSchema = function (values) {
  return Yup.object().shape({
    // email: Yup.string()
    // .email('E-mail inválido!')
    // .required('E-mail é obrigatório!'),
    password: Yup.string()
      // .min(6, `A senha necessita ter pelo menos ${6} caracteres!`)
      .required('Digite a senha'),
  })
}

const validate = (getValidationSchema) => {
  return (values) => {
    const validationSchema = getValidationSchema(values)
    try {
      validationSchema.validateSync(values, { abortEarly: false })
      return {}
    } catch (error) {
      return getErrorsFromValidationError(error)
    }
  }
}

const getErrorsFromValidationError = (validationError) => {
  const FIRST_ERROR = 0
  return validationError.inner.reduce((errors, error) => {
    return {
      ...errors,
      [error.path]: error.errors[FIRST_ERROR],
    }
  }, {})
}

const initialValues = {
  email: "",
  password: "",
}

// class Login extends Component {
export default function Login() {

  const error = cookies.get('error', { path: '/' });


  const dispatch = useDispatch();
  // const isSubmitting = useSelector(state => state.auth.loading);

  function onSubmit(values, { setSubmitting, setErrors }) {
    // console.tron.log("FORM: " + JSON.stringify(values, null, 2));
    cookies.remove('error', { path: '/' });
    const { email, password } = values;

    dispatch(signInRequest(email, password));
  }

  return (
    <div className="app flex-row align-items-center">
      <Container className="containerLogin">
        <Container className="headerLogin">
          <Row className="justify-content-center">
            
          </Row>
        </Container>
        <Container className="formLogin">
          <Formik
            initialValues={initialValues}
            validate={validate(validationSchema)}
            onSubmit={onSubmit}
            render={
              ({
                values,
                errors,
                touched,
                status,
                dirty,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isValid,
                handleReset,
                setTouched
              }) => (
                <Row className="justify-content-center">
                  <img src={LogoHeader} alt={`Novidá ${new Date().getFullYear()}`} style={{ "width": "290px", "height": "60px","object-fit": "cover" , "position": "absolute" , "margin": "-90px 0px 0px 0px"}} />
                  <Col md="12">
                    
                    <CardGroup>
                      <Card className="cardLogin p-4">
                        <CardBody>
                          <Form onSubmit={handleSubmit} noValidate name='Acessar'>
                            <h1>Acessar</h1>
                            <FormGroup>
                              <Label for="email">E-mail</Label>
                              <Input type="email"
                                name="email"
                                id="email"
                                placeholder="E-mail"
                                autoComplete="email"
                                valid={!errors.email}
                                invalid={touched.email && !!errors.email}
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email} />
                              <FormFeedback>{errors.email}</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                              <Label for="password">Senha</Label>
                              <Input type="password"
                                name="password"
                                id="password"
                                placeholder="Senha"
                                autoComplete="new-password"
                                valid={!errors.password}
                                invalid={touched.password && !!errors.password}
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password} />
                              <FormFeedback>{errors.password}</FormFeedback>
                            </FormGroup>
                            <Row>
                              <Col xs="12" style={{ 'textAlign': "center" }}>
                                <Button color="link" className="px-0" onClick={() => history.push('/esquecisenha?back=/')}>
                                  Esqueceu sua senha?
                                  </Button>
                                {/* <h6>{error}</h6> */}
                                <span style={{ 'color': "#f00" }}>{error}</span>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="12">
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="px-4"
                                  disabled={isSubmitting || !isValid}
                                >
                                  {isSubmitting ? 'Aguarde...' : 'Acessar'}
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </CardBody>
                      </Card>
                    </CardGroup>
                  </Col>
                </Row>
              )} />
        </Container>
        <Container className="footerLogin">
          <Row className="justify-content-center">
            <Col md="12">
              <p>NOVIDÁ {new Date().getFullYear()}</p>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
